import gql from 'graphql-tag';

const PRODUCT_FAMILY_FRAGMENT = gql`
  fragment BaseProductFamily on ProductFamily {
    id
    code
    name
    description
    iconUrl
    bannerUrl
    types
    pliManaged
  }
`;
export default PRODUCT_FAMILY_FRAGMENT;
